import { render, staticRenderFns } from "./ShopChatSearchBarComponent.vue?vue&type=template&id=0de7627e&scoped=true"
import script from "./ShopChatSearchBarComponent.vue?vue&type=script&lang=js"
export * from "./ShopChatSearchBarComponent.vue?vue&type=script&lang=js"
import style0 from "./ShopChatSearchBarComponent.vue?vue&type=style&index=0&id=0de7627e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de7627e",
  null
  
)

export default component.exports